import { createContext, useEffect, useRef, useState } from "react";
// import dataClient from "../../../assets/Json/dataClient.json";

export const HomeContext = createContext();

export default function HomeContextProvider(props) {
  const [assetsLoaded, setAssetsLoaded] = useState(false);
  const [imagesPreloaded, setImagesPreloaded] = useState();
  const [dataClient, setDataClient] = useState();

  async function getData() {
    const url = "/Json/dataClient.json";
    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }

      const json = await response.json();
      setDataClient(json);
    } catch (error) {
      console.error(error.message);
    }
  }

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if(dataClient) {
      setRose({
        roseType: dataClient.design?.typeRose[0].item,
        roseColor: dataClient.design?.colorRose[0],
        roseTexture : dataClient.design?.colorRose[0].texture,
      });
      setQuantity(dataClient.design?.packaging?.quantity[0])
      
      
    }
  }, [dataClient])

  useEffect (() => {
    if(imagesPreloaded) {
      let var1 = imagesPreloaded[2].getAttribute('src');
      console.log("var1" , var1);
    }
    
    console.log("imagesPreloaded" , imagesPreloaded);
    
  }, [imagesPreloaded])

  // Design Tabs
  const [designPanelMenu, setDesignPanelMenu] = useState(1);
  const [activeTab, setActiveTab] = useState("AddText");

  // Rose
  const [rose, setRose] = useState();

  // Text Design
  const [textDesign, setTextDesign] = useState({
    fontFamily: "Roboto",
    fontFamilyPath: "/CustomizerFont/Roboto-VariableFont_wdth,wght.ttf",
    selectedTextColor: {
      id: 1,
      hex: "#000000",
      check: "#FFFFFF",
    },
    text: {
      line1: "Your",
      line2: "Design",
      line3: "Here",
      line4: "",
    },
  });

  // Image Tab
  const [croppedImage, setCroppedImage] = useState("/textures/logo-silver.png");
  const [imageR, setImageR] = useState("/textures/logo-silver.png");
  const handleCropComplete = (croppedImg) => {
    setCroppedImage(croppedImg);
  };

  // Clipar Tab
  const [cliPart, setCliPart] = useState(null);

  // Packaging Part
  const [material, setMaterial] = useState({
    id: 1,
    title: "acrylic",
  });
  const [quantity, setQuantity] = useState();
  const [boxSelected, setBoxSelected] = useState();

  // Order Part
  const [isActive1, setIsActive1] = useState(true);
  const [activeSection, setActiveSection] = useState(1);
  const [prevActiveSection, setPrevActiveSection] = useState();

  const sectionRefs = Array(3)
    .fill(null)
    .map(() => ({ current: null })); // ایجاد رفرنس برای هر بخش

  const handleScrollTo = (index) => {
    const section = sectionRefs[index].current;
    if (section) {
      section.scrollIntoView({ behavior: "smooth", block: "center" });
      // setActiveSection(index + 1);
    }
  };

  // Size Image
  const [sizeImage, setSizeImage] = useState(1);

  // Price Part
  const [cost, setCost] = useState(200);
  const [addToCard, setAddToCard] = useState(false);

  // Loading
  const [loading, setLoading] = useState(false);
  const [loadingMain, setLoadingMain] = useState(true);

  const [flagScroll, setFlagScroll] = useState(false);
  const [flagScrollImage, setFlagScrollImage] = useState(false);

  const imageUploadRefMob = useRef(null);

  const contextValue = {
    assetsLoaded,
    imagesPreloaded,
    setImagesPreloaded,
    setAssetsLoaded,
    dataClient,
    rose,
    setRose,
    textDesign,
    setTextDesign,
    material,
    setMaterial,
    boxSelected,
    setBoxSelected,
    loading,
    setLoading,
    loadingMain,
    setLoadingMain,
    designPanelMenu,
    setDesignPanelMenu,
    quantity,
    setQuantity,
    cliPart,
    setCliPart,
    activeSection,
    setActiveSection,
    handleScrollTo,
    sectionRefs, // ارسال کل آبجکت رفرنس (همان useRef)
    activeTab,
    setActiveTab,
    cost,
    setCost,
    addToCard,
    setAddToCard,
    isActive1,
    setIsActive1,
    prevActiveSection,
    setPrevActiveSection,
    sizeImage,
    setSizeImage,
    flagScroll,
    setFlagScroll,
    flagScrollImage,
    setFlagScrollImage,
    imageR,
    setImageR,
    croppedImage,
    setCroppedImage,
    handleCropComplete,
    imageUploadRefMob,
  };
  return (
    <HomeContext.Provider value={contextValue}>
      {props.children}
    </HomeContext.Provider>
  );
}
